import { ILanguage } from '@core/interfaces';
import { Entity } from './entity';

export class Language extends Entity<ILanguage> {
  constructor(props: ILanguage) {
    super(props);
  }

  get code() {
    return this.props.code;
  }

  get name() {
    return this.props.name ?? '';
  }
}
